import axios from 'axios'
import { getAttributes, getLocale, constants as c } from '../imports'
import {
    // Constants
    MOTD_OUTDATED,
    MOTD_FETCHED,
    ADD_MESSAGE,
    REMOVE_TOAST,
    REMOVE_TOASTS,
    BUTTON_CLICKED,

    // Actions
    fetchingMotd,
    fetchedMotd,
    fetchFailedMotd,
    motdsChanged,
    reshowLatestMotd,
    setVisibility,
    removeToasts,

    // Selectors
    getVisible,
    getDisplayToasts,
    getMotdsForStorage,
    getTempTimeStamp,
    getLatestMotdTimeStamp,
    getLatestMotd,
} from '../data'

export function fetchMotd(locale) {
    // Now create the URL:
    const attributes = getAttributes(locale)
    const url = attributes.url.replace('{locale}', locale)

    // console.info('motd url: ', url)

    // Do the actual fetching
    return axios.get(url).then((response) => {
        // Make sure that we received a valid response status
        // otherwise throw an error with the response status
        if (response.status !== 200) throw Error(response.status)

        // console.log('fetched', response.data)

        // if (response.data.error) {
        //     throw Error(`(From lambda) ${response.data.errorMessage}`)
        // }

        // Return the ads
        return response.data
    })
}

const fetch = (dispatch, locale, timeStamp) => {
    // Let know that I am fetching
    dispatch(fetchingMotd(locale, timeStamp))

    fetchMotd(locale)
        .then((motd) => {
            // Update the state with the new motd information
            dispatch(fetchedMotd(locale, motd))
        })
        .catch((error) => {
            console.info(`Error occurred while fetching motd content: ${error.message}`)
            dispatch(fetchFailedMotd(locale, timeStamp))
        })
}

const ToasterMiddleware = store => next => (action) => {
    switch (action.type) {
        case MOTD_OUTDATED: {
            const state = store.getState()

            // Start by getting the latest timestamp
            const latest = getLatestMotdTimeStamp(state)

            // If timestamp is unchanged, then nothing has changed
            if (latest === action.payload) {
                return next(action)
            }

            // If already fetching, then do nothing
            if (action.payload === getTempTimeStamp(state)) {
                return next(action)
            }

            // Get the current language
            const locale = getLocale(state)

            // Initiate a fetch for the current language
            fetch(store.dispatch, locale, action.payload)

            // And then continue the flow
            return next(action)
        }

        case c.LOCALE_CHANGED: {
            const state = store.getState()

            // Start by getting the latest motd
            const motd = getLatestMotd(state)
            // Get the current language
            const locale = action.payload

            // Motd does not exist
            if (motd == null) {
                // Initiate a fetch for the current language
                fetch(store.dispatch, locale, -1)
            }

            // Locale does not exist
            if (motd != null && motd.localized[locale] == null) {
                // Initiate a fetch for the current language
                fetch(store.dispatch, locale, motd.motd.timeStamp)
            }

            return next(action)
        }

        case MOTD_FETCHED:
        case ADD_MESSAGE:
        case REMOVE_TOAST:
        case REMOVE_TOASTS: {
            // todo: Maybe see if the value has actually changed and only dispatch
            // if so.
            const result = next(action)
            const motds = getMotdsForStorage(store.getState())
            // console.log('motds for localforage: ', motds)
            store.dispatch(motdsChanged(motds))
            return result
        }

        // Handle clicks (when user clicks on toast button)
        case BUTTON_CLICKED: {
            const result = next(action)
            const state = store.getState()

            // First we check the current state...
            const visible = getVisible(state)

            // Then we get the toasts that are currently on display
            const toasts = getDisplayToasts(state)

            if (visible && toasts.length < 1) {
                // Reshow the latest motd
                store.dispatch(reshowLatestMotd())
            } else if (visible) {
                // Get the ids of all toasts we are showing
                const ids = toasts.reduce((res, toast) => {
                    res.push(toast.id)
                    return res
                }, [])
                // Dismiss all open toasts
                store.dispatch(removeToasts(ids))
                // Change visibility to false
                store.dispatch(setVisibility(false))
            } else if (toasts.length > 0) {
                // Change visibility to true
                store.dispatch(setVisibility(true))
            } else {
                // Reshow the latest motd
                store.dispatch(reshowLatestMotd())
                // Change visibility to true
                store.dispatch(setVisibility(true))
            }

            return result
        }

        default:
            return next(action)
    }
}

export default ToasterMiddleware



// WEBPACK FOOTER //
// ./src/features/Toaster/middleware/index.js